interface MetaCartItem {
    idProductos?: number | string | null;
    barcode?: number | string | null;
    quantity: number;
    Precio: number;
}

interface MetaPixelWindow extends Window {
    fbq?: (...args: unknown[]) => void;
}

export type MetaStandardEvent =
    | 'PageView'
    | 'ViewContent'
    | 'InitiateCheckout'
    | 'FindLocation'
    | 'AddToCart'
    | 'Search'
    | 'AddPaymentInfo'
    | 'Contact'
    | 'CompleteRegistration';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const META_CONSENT_EVENT = 'fgv:analytics-consent-change';
export const hasMetaConsent = () => window.localStorage.getItem('fgv:analytics-consent') === 'accepted';

const isPublicStoreDomain = () => ['garciavidal.com', 'www.garciavidal.com'].includes(window.location.hostname);

const createEventId = () => {
    if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    return `fgv-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const cookieValue = (name: string) => {
    const prefix = `${name}=`;
    const cookie = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(prefix));
    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : '';
};

export const getMetaBrowserContext = () => ({
    eventSourceUrl: window.location.href,
    fbp: cookieValue('_fbp'),
    fbc: cookieValue('_fbc'),
    consent: hasMetaConsent(),
});

export const trackMetaEvent = (
    eventName: MetaStandardEvent,
    customData: Record<string, unknown> = {},
    eventId = createEventId(),
) => {
    if (!isPublicStoreDomain() || !hasMetaConsent()) return false;

    const { fbq } = window as MetaPixelWindow;
    if (typeof fbq === 'function') {
        fbq('track', eventName, customData, { eventID: eventId });
    }

    const { eventSourceUrl, fbp, fbc } = getMetaBrowserContext();
    void fetch(`${API_URL}/meta/events`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ eventName, eventId, eventSourceUrl, customData, fbp, fbc, consent: true }),
        keepalive: true,
    }).catch(() => undefined);
    return true;
};

export const trackMetaPurchase = (orderId: string, value: number, items: MetaCartItem[]) => {
    if (!isPublicStoreDomain() || !hasMetaConsent()) return false;
    const fbq = (window as MetaPixelWindow).fbq;
    if (typeof fbq !== 'function') return false;

    const contents = items
        .map(item => ({
            id: String(item.idProductos || item.barcode || ''),
            quantity: Number(item.quantity || 1),
            item_price: Number(item.Precio || 0),
        }))
        .filter(item => item.id);

    fbq('track', 'Purchase', {
        currency: 'ARS',
        value: Number(value || 0),
        content_type: 'product',
        content_ids: contents.map(item => item.id),
        contents,
        num_items: contents.reduce((sum, item) => sum + item.quantity, 0),
    }, { eventID: orderId });
    return true;
};
